import { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { useParams, useSearchParams } from 'react-router';

import FactsheetView from '@/features/Factsheet/components/FactsheetView';
import {
  ADDITIONAL_TABS_PARAM_NAME,
  FACTSHEET_PARAM_NAME,
  FACTSHEET_TAB_PARAM_NAME
} from '@/features/Factsheet/constants';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { useGxTokenFromStorage } from '@/services/storage';
import { loginTrip } from '@/slices/tripTokenSlice';

const Factsheets = () => {
  const params = useParams();
  const factsheetKey = params[FACTSHEET_PARAM_NAME];
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const [additionalTabs, setAdditionalTabs] = useState<string[]>([]);
  const gxToken = useGxTokenFromStorage();
  const dispatch = useAppDispatch();

  const setAdditionalTabsParam = (tabs: string[]) => {
    const newSearchParams = new URLSearchParams(urlSearchParams);

    if (tabs.length === 0) {
      newSearchParams.delete(ADDITIONAL_TABS_PARAM_NAME);
    } else {
      newSearchParams.set(ADDITIONAL_TABS_PARAM_NAME, tabs.join(','));
    }
    if (newSearchParams.get(FACTSHEET_TAB_PARAM_NAME) !== 'Flowchart')
      newSearchParams.delete(FACTSHEET_TAB_PARAM_NAME);
    setUrlSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (gxToken) {
      dispatch(loginTrip(gxToken));
    }
  }, [dispatch, gxToken]);

  useEffect(() => {
    const additionalTabsParam = decodeURIComponent(
      urlSearchParams.get(ADDITIONAL_TABS_PARAM_NAME) ?? ''
    );
    if (additionalTabsParam) {
      setAdditionalTabs(additionalTabsParam.split(','));
    }
  }, [urlSearchParams]);

  return (
    <Box
      sx={{
        backgroundColor: '#12163fcc',
        display: 'flex',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      {factsheetKey && (
        <FactsheetView
          factsheetKeys={[factsheetKey, ...additionalTabs].join(',')}
          setAdditionalTabsParam={setAdditionalTabsParam}
        />
      )}
    </Box>
  );
};

export default Factsheets;
